import {
  putRequest,
  trustedRequest,
  postRequest,
  delRequest,
} from 'utils/request';

const convertDataBeforePost = (data: any) => {
  const convertedData = {
    ...data,
  };

  if (data.photo && data.photo instanceof File) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(data.photo);
      reader.onload = () => {
        convertedData.photo = {
          fileData: reader.result,
          fileName: data.photo.name,
        };
        resolve(convertedData);
      };
      reader.onerror = (error) => {
        reject(error);
      };
    });
  }

  return convertedData;
};

/**
 * User API
 */
export const login = postRequest('/api/auth/login');
export const checkLogin = () => trustedRequest('/api/auth/login/status');
export const logout = () => trustedRequest('/api/auth/logout');
export const restore = putRequest('/api/auth/restore');
export const createRegRequest = postRequest('/api/auth/registration');
export const updateUserProfile = async (data: object) => {
  const convertedData = await convertDataBeforePost(data);
  const result = await putRequest('/api/auth/profile')(convertedData);
  return result;
};

/**
 * Cart API
 */
export const addProductToCart = postRequest('/api/cart');
export const getCartProducts = () => trustedRequest('/api/cart');
export const deleteFromCart = (no: number) => delRequest(`/api/cart/${no}`);
export const updateProductInCart = putRequest('/api/cart');
export const getServiceCenters = () => trustedRequest('/api/cart/services');

export const orderAdd = async (data: object) => {
  const convertedData = await convertDataBeforePost(data);
  const currentDate = new Date();
  const date = currentDate.toLocaleDateString('ru-RU',
    {hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: false},
  );
  const result = await postRequest('/api/cart/order')({...convertedData, date});
  return result;
};

export const sendOfferPdf = postRequest('/api/cart/offer');


/**
 * Profile API
 */

 export const changePassword = putRequest('/api/profile/password');
